import { Link } from "react-router-dom";
import { classNames } from "@/lib/format";

const tab = (section, key, label, to) => ({ key, label, to, testid: `section-tab-${section}-${key}` });

export const SECTION_TABS = {
  home: [tab("home", "overview", "Overview", "/"), tab("home", "analytics", "Analytics", "/analytics")],
  creators: [tab("creators", "monitored", "Monitored", "/creators"), tab("creators", "watchlists", "Watchlists", "/watchlists")],
  signals: [tab("signals", "outliers", "Outliers", "/outliers"), tab("signals", "trends", "Trends", "/trends")],
  studio: [tab("studio", "hook-remix", "Hook Remix", "/hook-lab"), tab("studio", "patterns", "Patterns", "/patterns")],
  decisions: [tab("decisions", "decisions", "Decisions", "/decisions"), tab("decisions", "follow-ups", "Follow-ups", "/decisions?assignee=me")],
  settings: [tab("settings", "account", "Account", "/settings?tab=account"), tab("settings", "security", "Security", "/settings"), tab("settings", "notifications", "Notifications", "/settings?tab=notifications")],
};

export function settingsTabsForLocation(location) {
  return SECTION_TABS.settings.map((item) => {
    const params = new URLSearchParams(location.search);
    if (item.key === "security") params.delete("tab"); else params.set("tab", item.key);
    return { ...item, to: { pathname: "/settings", search: params.toString() ? `?${params}` : "", hash: location.hash } };
  });
}

export default function SectionTabs({ tabs, activeKey, ariaLabel, ...props }) {
  return (
    <nav aria-label={ariaLabel} className="flex flex-wrap gap-x-4 gap-y-1 border-b border-border" {...props}>
      {tabs.map((item) => {
        const active = item.key === activeKey;
        return (
          <Link
            key={item.key}
            to={item.to}
            data-testid={item.testid}
            aria-current={active ? "page" : undefined}
            className={classNames("border-b-2 px-1 py-2 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", active ? "border-primary text-primary font-semibold" : "border-transparent text-muted-foreground hover:border-border hover:text-foreground")}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
